/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Report_No_DataInputs */

const vi_expense_report_no_data = /** @type {(inputs: Expense_Report_No_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có dữ liệu`)
};

/**

* @param {Expense_Report_No_DataInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_report_no_data = /** @type {((inputs?: Expense_Report_No_DataInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Report_No_DataInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_report_no_data(inputs)
});